<template>
<div>
    <section class="page-title" style="margin-top: 0px;">
        <v-img 
        max-height="600px"        
        :src="require('@/Content/images/fundo.jpg')"
        class="white--text"
        
        max-width="100%"          
      >
    <div class="center">
      <v-layout row wrap>
        <v-flex xs12 sm12 lg6 style="text-align: center;">
        <h1 class="the-title" style="font-size:60px;color:white;">Plano Dental</h1>   
        <br>
        <p style="font-size:35px;color:white;">Condições especiais</p>
        <br>
        <p style="font-size:35px;color:white;">para o fiel torcedor </p>
        <br>
        <p style="font-size:35px;color:white;">cuidar do seu sorriso.</p>
        <br>
        <br>
        <h1 class="the-title" style="font-size:40px;color:#F57C00;">Mensal por pessoa</h1>
        <h1 class="the-title" style="font-size:40px;color:#F57C00;">R$ 29,90</h1>
        </v-flex> 
        </v-layout> 
        <v-layout row wrap >
        <v-flex xs12 sm12 lg3 style="text-align: center;" v-if="this.$vuetify.breakpoint.lg">  
             <img src="../Content/images/logo_pv_branco.png" width="180px">
        </v-flex>
        <v-flex xs12 sm12 lg3 style="text-align: center;" v-else>  
             <img src="../Content/images/logo_pv_branco.png" width="180px">
        </v-flex>
        
        <v-flex xs12 sm12 lg3 style="text-align: center;" v-if="this.$vuetify.breakpoint.lg">  
             <img src="../Content/images/logo fiel.png" width="180px">
        </v-flex>
        <v-flex xs12 sm12 lg3 style="text-align: center;" v-else>  
             <img src="../Content/images/logo fiel.png" width="180px">
        </v-flex>  
       
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12 sm12 lg3 style="text-align: center; margin-top: -25px;" v-if="this.$vuetify.breakpoint.lg">  
              <img src="../Content/images/logoAns.jpeg" width="180px">
          </v-flex>
          <v-flex xs12 sm12 lg3 style="text-align: center; margin-top: -25px;" v-else>  
              <img src="../Content/images/logoAns.jpeg" width="180px">
          </v-flex>
        </v-layout>
    </div>
    </v-img>
</section>

<section class="page-content center">
    <v-layout row wrap>  
    <v-flex xs12 sm6 md6 lg6>
        <v-btn
        style="border-radius: 6px;"
        large                
        dark
        @click="openDialog()"
        color="#424242"
        >Faça já a sua adesão
        </v-btn>
    </v-flex>   
    <v-flex xs12 sm12 lg11>
    <br>
    <p class="title-label" style="color:#212121;">O seu sorriso é o nosso diferencial</p>
    <p>Aproveite a oportunidade de levar saúde bucal de qualidade para você e sua familia em condições imperdíveis.</p>

    </v-flex>


    <v-flex xs12 sm12 lg7>
    <p class="title-label" style="color:#212121;">Acesso à rede credenciada</p>
    <p>Para acessar a rede credenciada, <a href="http://www.primavida.com.br/redecredenciada" target="_blank" style="color:#1976d2">clique aqui.</a></p>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <p class="title-label" style="color:#212121;">Quem pode aderir ao Plano?</p>
    <ul>Dependentes:</ul>
    <li>Pai / Padrasto</li>
    <li>Mãe / Madrasta</li>
    <li>Filhos / Enteados</li>
    <li>Cônjuge / Companheiro</li>
    <br>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <p class="title-label" style="color:#212121;">Principais Vantagens</p>
    <li>Liberação on-line do seu plano de tratamento;</li>
    <li>O Beneficiário pode incluir familiares e agregados;</li>
    <li>Acesso a rede credenciada através do site www.primavida.com.br;</li>
    <li>Possibilidade de credenciamento de Dentistas por indicação do Associado;</li>
    <li>Desconto em medicamentos nas farmácias &nbsp;<img src="../Content/images/raia.jpg" width="60px"> &nbsp; <img src="../Content/images/drogasil.jpg" width="110px"></li>
    <li>Central de Atendimento exclusiva por Whatsapp;</li>
    <li>Aplicativo para Celular / Tablet com rede Credenciada;</li>
    <li>Carteirinha Virtual;</li>
    <li>Boleto Virtual;</li>
    <br>
    </v-flex>
    
    <v-flex xs12 sm12 lg12>
    <br>
    <p class="title-label" style="color:#212121;">App PrimaVida Beneficiário</p>    
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_android.png" width="120px"><br>
    <a href="https://play.google.com/store/apps/details?id=br.com.primavida.associado" target="_blank"><img src="../Content/images/android.png" width="120px"></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_apple.png" width="120px"><br>
    <a href="https://apps.apple.com/br/app/primavida-dental-associado/id1464690839" target="_blank"><img src="../Content/images/apple_stote.png" width="120px" ></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg5>
    <img src="../Content/images/app_whats.png" width="120px"><br>
    <a href="https://api.whatsapp.com/send?phone=5521971640379" target="_blank"><img src="../Content/images/whatsapp.png" width="120px" ></a>&nbsp;
    </v-flex>
    
    </v-layout>
    <br>
    <p class="title-label" style="color:#212121;">Carências reduzidas</p>    
    <table class="table-carencia" cellpadding="0" cellspacing="0" border="0">
      <tr>
        <th></th>
        <th colspan="1" style="color:#616161">Carências</th>
      </tr>
      <tr class="mini-header">
        <td>Procedimentos</td>
        <!-- <td>Plano Individual/Familiar</td> -->
        <td class="carencia" style="background-color:#616161">Plano Individual/Familiar</td>
      </tr>
      <tr>
        <td>Consulta de Urgência</td>
        <!-- <td>24 horas</td> -->
        <td class="carencia" style="background-color:#616161">24 horas</td>
      </tr>
      <tr>
        <td>Consulta inicial, Radiologia, Prevenção</td>
        <!-- <td>30 dias</td> -->
        <td class="carencia" style="background-color:#616161">30 dias</td>
      </tr>
      <tr>
        <td>Odontopediatria, Periodontia, Dentística, Cirurgia Oral Menor</td>
        <!-- <td>60 dias</td> -->
        <td class="carencia" style="background-color:#616161">30 dias</td>
      </tr>
      <tr>
        <td>Endodontia e Prótese</td>
        <!-- <td>120 dias</td> -->
        <td class="carencia" style="background-color:#616161">180 dias</td>
      </tr>
    </table>


    <br>
    <p class="title-label" style="color:#212121;">Principais Coberturas (Rol da ANS)</p>
    <p>Smile Class - Reg ANS nº 484.400/19-9</p>
    <div class="icone consultas" >
        <!-- <span class="icon"></span> -->
        <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
    </div>
    <div class="icone urgencia">
        <!-- <span class="icon"></span> -->
        <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
    </div>
    <div class="icone cirurgia">
        <!-- <span class="icon"></span> -->
        <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
    </div>
    <div class="icone dentistica">
        <!-- <span class="icon"></span> -->
        <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
    </div>
    <div class="icone endodontia">
        <!-- <span class="icon"></span> -->
        <p><strong>Endodontia</strong> - Tratamento de canais;</p>
    </div>
    <div class="icone periodontia">
        <!-- <span class="icon"></span> -->
        <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
    </div>
    <div class="icone odontopediatria">
        <!-- <span class="icon"></span> -->
        <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
    </div>
    <div class="icone radiologia">
        <!-- <span class="icon"></span> -->
        <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico);</p>
    </div>
    <div class="icone protese">
        <!-- <span class="icon"></span> -->
        <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
    </div>
    <div class="icone profilaxia">
        <!-- <span class="icon"></span> -->
        <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
    </div>
    <div class="icone exodontia">
        <!-- <span class="icon"></span> -->
        <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
    </div>
    <div>
        <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank" style="color:#1976d2;">clique aqui.</a></p>
    </div>
    <v-flex xs12 sm6 md6 lg6 >
        <v-btn
        style="border-radius: 6px;"
        large                
        dark
        @click="openDialog()"
        color="#424242"
        >Faça já a sua adesão</v-btn>
    </v-flex>
</section>
<v-dialog v-model="dialog" max-width="700px" max-height="400px" > 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total" style="color:#616161">Prezado(a) parceiro(a),</span>              
              </v-card-title>
              <v-container                    
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" style="color:#616161">Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
              <p class="resumo" style="color:#616161">Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
              <p class="resumo" style="color:#616161">É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
              <br>
              <v-flex xs12 sm12 lg6>      
                <v-text-field
                v-model="matricula"
                label="Matrícula fiel torcedor"
                v-validate="'required'"
                :error-messages="errors.collect('carteirinha')"
                data-vv-name="carteirinha" 
                outline
                color="#616161"
                mask="#########################"     
                ></v-text-field>
            </v-flex>
              <p class="resumo" style="font-weight: bold">A <span style="color:#616161">PrimaVida Dental</span> agradece a sua atenção !</p>
              <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
              <br>
              <p class="resumo" style="font-weight: bold;color:#616161">Termo de Privacidade, <a href="https://ecommerce.primavida.com.br/contratos/Politica_de_Privacidade_PrimaVida_LGPD.pdf" target="_blank">clique aqui.</a></p>
              
              <v-checkbox
                    v-model="contrataccept"
                    color="#616161"
                    :disabled="!check"
                >
                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da PrimaVida Dental.</span>
          </v-checkbox>          
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
                  <br>
              <v-btn :disabled="!contrataccept" color="#616161" depressed style="border-radius: 8px; width: 130px;color: white;" :href="'https://ecommerce.primavida.com.br/contratopf?plano=5fa2c9a9a6d87b236caf1ac2&parceria=fiel&carteirinha='+matricula">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
<Snackbar ref=chamaSnackbar />
</div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
export default {
    components: {Snackbar},
     data(){
        return{   
                contrataccept: false,
                dialog: false,
                check: false,
                matricula: '',
                dictionary: {          
                custom: {               
                carteirinha: {
                  required: () => 'Informe o número da carteirinha'
                } 
                }
                }
        }               
    },

    mounted : function(){
        this.$store.dispatch('EscondeToolbar')
        this.$store.dispatch('EscondeFooter')
        this.$validator.localize('pt', this.dictionary)
        localStorage.clear()
        sessionStorage.clear()

    },
     watch: {
        dialog(val) {
        val || this.close()
      },
      matricula(val) {
        if(val != '')
        this.check = true
        else
        {
        this.contrataccept = false
        this.check = false
        }
      }
     },
    methods: {
        openDialog(){
            this.dialog = true
        }
        
    }

}
</script>

<style scoped>

    .fiel_titulo{
        text-align: right;
        color: whitesmoke;
    }
    .fiel_texto{
        text-align: right;
        color: whitesmoke;
        font-size:35px;
    }
    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .tabela{
        border-collapse: separate;
        border-spacing: 2;
    }
</style>